/**
 * Get the landkreis id from the AGS
 *
 * @param ags AGS of the landkreis
 * @returns The first 5 characters of the AGS as landkreis id
 */
export const getLandkreisId = (ags: string) => ags.slice(0, 5);
